// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { submit, change } from 'redux-form';

const ControlButtonsForCreateAndEditWorkOrder = ({
  editingWorkOrderStatus,
  history,
  submit,
  change,
}) => {
  const cancel = (event) => {
    event.preventDefault();
    history.goBack();
  };

  const handlerSave = async event => {
    event.preventDefault();
    await change(
      'createWorkOrderReduxForm',
      'status',
      editingWorkOrderStatus === 'assigned' ? 'assigned' : 'published',
    );
    submit('createWorkOrderReduxForm');
  };

  const handlerSaveAsDraft = async event => {
    event.preventDefault();
    await change(
      'createWorkOrderReduxForm',
      'status',
      'draft',
    );
    submit('createWorkOrderReduxForm');
  };

  return (
    <div className="create_actions">
      <button
        type="button"
        className="dashboard-btn dashboard-btn--secondary"
        aria-label="cancel"
        onClick={cancel}
      >
        Cancel
      </button>
      {editingWorkOrderStatus !== 'assigned' ? (
        <button
          type="button"
          name="draft"
          className="dashboard-btn dashboard-btn--secondary"
          aria-label="save as draft"
          onClick={handlerSaveAsDraft}
        >
          Save As Draft
        </button>
      ) : null}
      <button
        type="button"
        name={editingWorkOrderStatus === 'assigned' ? 'assigned' : 'published'}
        className="dashboard-btn dashboard-btn--primary"
        aria-label="save and publish"
        onClick={handlerSave}
      >
        Save
        {editingWorkOrderStatus === 'assigned' ? '' : ' And Publish'}
      </button>
    </div>
  );
};

const mapDispatchToProps = {
  submit,
  change,
};

export default connect(null, mapDispatchToProps)(ControlButtonsForCreateAndEditWorkOrder);
